import { render, staticRenderFns } from "./advanceSumSettingsComponent.vue?vue&type=template&id=0fba9a2c"
import script from "./advanceSumSettingsComponent.vue?vue&type=script&lang=js"
export * from "./advanceSumSettingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports